import { walkTree } from '../../components/Tree/helpers/helpers';
import { destructId, hasUnpublished, hasUntranslated } from './treeNode';

export const getCategoryStatus = (treeData) => {
  const publish = {};
  const translate = {};

  const invalidCategoryImage = {};
  const callback = ({ node, path }) => {
    if (!node?.category) {
      return;
    }
    if (hasUnpublished(node)) {
      addPaths(publish, node.category.categoryId, path);
    }
    if (hasUntranslated(node)) {
      addPaths(translate, node.category.categoryId, path);
    }
    if (node.invalidCategoryImage) {
      addPaths(invalidCategoryImage, node.category.categoryId, path);
    }
  };

  walkTree({
    treeData,
    callback,
    ignoreCollapsed: false,
  });

  return {
    unpublishedCategories: mapToDto(publish),
    untranslatedCategories: mapToDto(translate),
    invalidCategoryImages: mapToDto(invalidCategoryImage),
  };
};

function addPaths(source, categoryId, path) {
  const paths = source[categoryId] || [];
  paths.push(path.map((p) => destructId(p).value));

  source[categoryId] = paths;
}

function mapToDto(source) {
  return Object.entries(source).map(([categoryId, paths]) => ({
    catalogId: paths[0][0],
    categoryId,
    paths: paths.map((p) => p.slice(1)),
  }));
}
